import { normalizeSuggestionKeywords } from "@/components/suggestions/providers/utils/normalizeKeywords";
import { selectedPowerValue } from "@/input/utils/powerValue";
import { getSymbolContainingNode } from "@/models/nodes/utils";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";

export const powerValueSuggestionsProvider: SuggestionProvider = {
  type: "powerValue",
  search: (_str, doc) => {
    const selected = selectedPowerValue(doc);

    if (!selected) {
      return [];
    }

    const { power, count } = selected;

    const moveDown: SingleSuggestion = {
      type: "single",
      item: { type: "operator", intlName: "operator.moveDown", symbol: "" },
      action: { type: "demote-power", powerId: power.id, count },
      keywords: normalizeSuggestionKeywords({ keywords: ["demote", "lower", "exponent"] }),
      icon: "math/power/DemotePower",
      forceIcon: true,
      popupGroup: "labels",
      priority: 1,
    };

    if (!getSymbolContainingNode(power)) {
      return [[moveDown]];
    }

    const moveToLabel: SingleSuggestion = {
      type: "single",
      item: { type: "operator", intlName: "operator.moveToRightTopLabel", symbol: "" },
      action: { type: "move-power-value-to-label", powerId: power.id, count },
      keywords: normalizeSuggestionKeywords({ keywords: ["label", "superscript"] }),
      icon: "labels/InfrontRightTopLabel",
      forceIcon: true,
      popupGroup: "labels",
      priority: 0.9,
    };

    return [[moveDown, moveToLabel]];
  },
};
